import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetAllTranslationsRPC } from "./getAllTranslationsRPC";

export class GetAllTranslationsRPCClientImpl extends GetAllTranslationsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetAllTranslationsRPC.Request): Promise<LeoRPCResult<GetAllTranslationsRPC.Response, GetAllTranslationsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GetAllTranslations",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetAllTranslationsRPC.ResponseDTO,
      GetAllTranslationsRPC.Errors.ErrorsDTO,
      GetAllTranslationsRPC.Response,
      GetAllTranslationsRPC.Errors.Errors
    >(
      response,
      "survey/GetAllTranslations",
      GetAllTranslationsRPC.Response.fromDTO,
      GetAllTranslationsRPC.Errors.fromDTO
    );
  }
}
